export function metadataObject(value: unknown): Record<string, any> {
  try { const parsed = typeof value === 'string' ? JSON.parse(value) : value;
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
  } catch { return {}; }
}
export function crowdCount(metadata: unknown): number | null {
  const count = metadataObject(metadata).crowd?.people_count;
  return typeof count === 'number' && Number.isSafeInteger(count) && count >= 0 ? count : null;
}
